(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["andarta-free-gift-threshold"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('andarta-free-gift')) {
    class AndartaFreeGift extends HTMLElement {
      connectedCallback() {
        this.maxCents = parseInt(this.dataset.maxCents, 10) || 0;
        this.currency = this.dataset.currency || 'EUR';
        this.sectionId = this.dataset.sectionId;
        this.autoAdd = this.dataset.autoAdd === 'true';
        this.progressTemplate = this.dataset.progressTemplate || '';
        this.giftLabel = this.dataset.giftLabel || '';

        this.msgProgress = this.querySelector('[data-message-progress]');
        this.msgSuccess = this.querySelector('[data-message-success]');
        this.fillEl = this.querySelector('[data-fill]');
        this.barEl = this.querySelector('[data-bar]');
        this.hintEl = this.querySelector('[data-hint]');
        this.markers = Array.from(this.querySelectorAll('[data-marker]'));

        // Paliers triés par seuil croissant (ordre DOM déjà trié côté Liquid)
        this.tiers = Array.from(this.querySelectorAll('[data-tier]')).map(el => ({
          el,
          cents: parseInt(el.dataset.thresholdCents, 10) || 0,
          label: el.dataset.label || this.giftLabel,
          hideLocked: el.hasAttribute('data-hide-locked'),
          cards: Array.from(el.querySelectorAll('.andarta-fg__gift-card')),
          addBtn: el.querySelector('[data-add-btn]'),
          reached: false,
          giftLines: []
        }));

        // product_id -> palier (sert à rattacher une ligne cadeau à son palier)
        this.tierByProduct = new Map();
        this.tiers.forEach(tier => {
          tier.cards.forEach(card => {
            const pid = card.querySelector('.andarta-fg__radio')?.dataset.productId;
            if (pid && !this.tierByProduct.has(pid)) this.tierByProduct.set(pid, tier);
          });
        });

        this.busy = false;
        this.pendingRefresh = false;
        this.pendingOpts = null;
        this.failedVariants = new Set();
        this.designMode = !!(window.Shopify && window.Shopify.designMode);

        this.bindEvents();
        this.tiers.forEach(tier => {
          this.restoreSelection(tier);
          this.autoSelectSingleChoice(tier);
        });
        this.fetchCart();

        // BRIDGE Dawn PubSub natif (publish via cart.js, product-form.js, quick-add...)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
            if (e && e.source === 'andarta-free-gift') return;
            if (e && e.cartData && typeof e.cartData.items !== 'undefined') {
              this.update(e.cartData);
            } else {
              this.fetchCart();
            }
          });
        }
        // Fallback DOM events (sections custom Andarta qui dispatch ces events)
        this.onCartUpdated = (e) => {
          if (e && e.detail && e.detail.source === 'andarta-free-gift') return;
          this.fetchCart();
        };
        document.addEventListener('cart:updated', this.onCartUpdated);
        document.addEventListener('cart:refresh', this.onCartUpdated);
      }

      disconnectedCallback() {
        try { this.unsubCartUpdate?.(); } catch {}
        if (this.onCartUpdated) {
          document.removeEventListener('cart:updated', this.onCartUpdated);
          document.removeEventListener('cart:refresh', this.onCartUpdated);
        }
      }

      bindEvents() {
        this.tiers.forEach(tier => {
          tier.cards.forEach(card => {
            const colorSel = card.querySelector('[data-opt-color]');
            const sizeSel = card.querySelector('[data-opt-size]');

            // Click sur la carte = sélection (sauf si click sur un select/option/label interactif)
            card.addEventListener('click', (e) => {
              if (e.target.closest('select, option, .andarta-fg__gift-options')) return;
              if (!tier.reached) return;
              this.selectCard(tier, card);
              this.onSelectionChange(tier);
            });
            card.addEventListener('keydown', (e) => {
              if (e.target.closest('select, option, .andarta-fg__gift-options')) return;
              if (!tier.reached) return;
              if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                this.selectCard(tier, card);
                this.onSelectionChange(tier);
              }
            });

            if (colorSel && colorSel.tagName === 'SELECT') {
              colorSel.addEventListener('change', (e) => {
                e.stopPropagation();
                this.filterSizesByColor(card);
                this.onSelectionChange(tier);
              });
              colorSel.addEventListener('click', (e) => e.stopPropagation());
            }
            if (sizeSel && sizeSel.tagName === 'SELECT') {
              sizeSel.addEventListener('change', (e) => {
                e.stopPropagation();
                this.onSelectionChange(tier);
              });
              sizeSel.addEventListener('click', (e) => e.stopPropagation());
            }
          });

          if (tier.addBtn) {
            tier.addBtn.addEventListener('click', () => this.reconcile(this.lastCart, { manualTier: tier }));
          }
        });
      }

      selectCard(tier, card) {
        // Décoche les autres cartes du palier
        tier.cards.forEach(c => {
          c.setAttribute('aria-checked', c === card ? 'true' : 'false');
          const options = c.querySelector('[data-gift-options]');
          if (options) options.hidden = c !== card;
          const r = c.querySelector('.andarta-fg__radio');
          if (r) r.checked = (c === card);
        });
        // Filter tailles selon couleur de la carte sélectionnée
        const colorSel = card.querySelector('[data-opt-color]');
        if (colorSel && colorSel.tagName === 'SELECT') this.filterSizesByColor(card);
      }

      // Palier à choix unique (1 produit, 1 variante dispo) : sélection d'office, rien à choisir
      autoSelectSingleChoice(tier) {
        if (tier.cards.length !== 1) return;
        const card = tier.cards[0];
        if (card.dataset.singleChoice !== 'true') return;
        if (card.getAttribute('aria-checked') === 'true') return;
        this.selectCard(tier, card);
        const sizeSel = card.querySelector('[data-opt-size]');
        if (sizeSel && sizeSel.tagName === 'SELECT') {
          const firstAvailable = [...sizeSel.options].find(o => !o.disabled);
          if (firstAvailable) sizeSel.value = firstAvailable.value;
        }
      }

      filterSizesByColor(card) {
        const colorSel = card.querySelector('[data-opt-color]');
        const sizeSel = card.querySelector('[data-opt-size]');
        if (!sizeSel || sizeSel.tagName !== 'SELECT') return;
        const targetColor = colorSel?.value;
        let firstAvailable = null;

        [...sizeSel.options].forEach(opt => {
          const optColor = opt.dataset.color || '';
          const opt_available = opt.dataset.available === 'true';
          if (!targetColor || optColor === targetColor) {
            opt.hidden = false;
            if (opt_available && !firstAvailable) firstAvailable = opt.value;
          } else {
            opt.hidden = true;
          }
        });
        const current = sizeSel.options[sizeSel.selectedIndex];
        if (firstAvailable && (!current || current.hidden || current.disabled || !sizeSel.value)) {
          sizeSel.value = firstAvailable;
        }
      }

      selectionKey(tier) {
        return 'andarta-fg-sel-' + this.sectionId + '-' + tier.cents;
      }

      restoreSelection(tier) {
        let saved = null;
        try { saved = JSON.parse(localStorage.getItem(this.selectionKey(tier)) || 'null'); } catch {}
        if (!saved) return;
        const card = tier.cards.find(c => c.querySelector('.andarta-fg__radio')?.value === saved.blockId);
        if (!card) return;
        this.selectCard(tier, card);
        const colorSel = card.querySelector('[data-opt-color]');
        const sizeSel = card.querySelector('[data-opt-size]');
        if (colorSel && colorSel.tagName === 'SELECT' && saved.color) {
          colorSel.value = saved.color;
          this.filterSizesByColor(card);
        }
        if (sizeSel && sizeSel.tagName === 'SELECT' && saved.variantId) {
          const opt = [...sizeSel.options].find(o => o.value === saved.variantId && !o.disabled && !o.hidden);
          if (opt) sizeSel.value = saved.variantId;
        }
      }

      // Aligne l'UI sur le cadeau réellement présent dans le panier pour ce palier
      syncSelectionFromCart(tier, line) {
        const card = tier.cards.find(c => c.querySelector('.andarta-fg__radio')?.dataset.productId === String(line.product_id));
        if (!card) return;
        if (card.getAttribute('aria-checked') !== 'true') this.selectCard(tier, card);
        const sizeSel = card.querySelector('[data-opt-size]');
        if (!sizeSel || sizeSel.tagName !== 'SELECT') return;
        const opt = [...sizeSel.options].find(o => o.value === String(line.variant_id));
        if (!opt) return;
        const colorSel = card.querySelector('[data-opt-color]');
        if (colorSel && colorSel.tagName === 'SELECT' && opt.dataset.color) {
          colorSel.value = opt.dataset.color;
          this.filterSizesByColor(card);
        }
        sizeSel.value = opt.value;
      }

      getActiveSelection(tier) {
        const checkedRadio = tier.el.querySelector('.andarta-fg__radio:checked');
        if (!checkedRadio) return null;
        const card = checkedRadio.closest('.andarta-fg__gift-card');
        const sizeSel = card.querySelector('[data-opt-size]');
        const colorSel = card.querySelector('[data-opt-color]');
        const sizeVal = sizeSel?.value;
        if (!sizeVal) return null;
        let size = 'default';
        if (sizeSel.tagName === 'SELECT') {
          const opt = sizeSel.options[sizeSel.selectedIndex];
          if (!opt || opt.disabled) return null;
          size = opt.dataset.size || '';
        }
        return {
          blockId: checkedRadio.value,
          productId: checkedRadio.dataset.productId,
          variantId: sizeVal,
          color: colorSel?.value || '',
          size
        };
      }

      onSelectionChange(tier) {
        // Le choix du client prime : on ne réaligne plus l'UI de ce palier sur le panier
        tier.userTouched = true;
        const sel = this.getActiveSelection(tier);
        if (tier.addBtn) tier.addBtn.disabled = !sel;
        if (!sel) return;
        try { localStorage.setItem(this.selectionKey(tier), JSON.stringify(sel)); } catch {}
        // Si auto_add ON : ajout immédiat, ou swap si un autre cadeau du palier est déjà au panier
        if (this.autoAdd && tier.reached && !this.designMode) {
          this.reconcile(this.lastCart, { swapTier: tier });
        }
      }

      async fetchCart(opts) {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!res.ok) return;
          const cart = await res.json();
          this.update(cart, opts);
        } catch (e) { console.warn('[AndartaFreeGift] fetchCart failed', e); }
      }

      isGiftItem(item) {
        if (!item) return false;
        if (item.properties && (item.properties._gift === 'true' || item.properties._gift === true)) return true;
        if (this.tierByProduct.has(String(item.product_id))) return true;
        if (item.product_type === 'Cadeau') return true;
        if (item.title && item.title.toLowerCase().startsWith('cadeau ')) return true;
        if (item.handle && item.handle.startsWith('cadeau-')) return true;
        return false;
      }

      // Seuil (centimes) auquel une ligne cadeau est rattachée
      giftLineCents(item) {
        const fromProp = parseInt(item.properties && item.properties._gift_tier, 10);
        if (fromProp > 0 && this.tiers.some(t => t.cents === fromProp)) return fromProp;
        const tier = this.tierByProduct.get(String(item.product_id));
        if (tier) return tier.cents;
        if (fromProp > 0) return fromProp;
        // Cadeau inconnu de la config (ancien panier) : rattaché au palier le plus haut
        return this.maxCents;
      }

      // Lit le panier, répartit les cadeaux par palier, met à jour l'affichage
      readCart(cart) {
        const gifts = (cart.items || []).filter(i => this.isGiftItem(i));
        const giftCents = gifts.reduce((sum, i) => sum + (i.final_line_price || 0), 0);
        const total = Math.max(0, (cart.total_price || 0) - giftCents);
        this.tiers.forEach(tier => {
          tier.reached = total >= tier.cents;
          tier.giftLines = [];
        });
        const orphans = [];
        gifts.forEach(line => {
          const cents = this.giftLineCents(line);
          const tier = this.tiers.find(t => t.cents === cents);
          if (tier) tier.giftLines.push(line);
          else orphans.push({ line, cents });
        });
        return { total, orphans };
      }

      update(cart, opts = {}) {
        if (!cart) return;
        if (this.busy) {
          // Une opération est en cours : on relira le panier à la fin
          this.pendingRefresh = true;
          return;
        }
        this.lastCart = cart;
        const { total } = this.readCart(cart);
        this.render(total);
        this.reconcile(cart, opts);
      }

      render(total) {
        const pct = this.maxCents > 0 ? Math.min(100, (total / this.maxCents) * 100) : 0;
        if (this.fillEl) this.fillEl.style.inlineSize = `${pct}%`;
        if (this.barEl) this.barEl.setAttribute('aria-valuenow', String(Math.round(pct)));
        this.markers.forEach(m => {
          m.toggleAttribute('data-reached', total >= (parseInt(m.dataset.thresholdCents, 10) || 0));
        });

        const nextTier = this.tiers.find(t => !t.reached);
        if (nextTier) {
          this.dataset.state = 'progress';
          if (this.msgProgress) this.msgProgress.hidden = false;
          if (this.msgSuccess) this.msgSuccess.hidden = true;
          this.renderProgress(this.formatPrice(nextTier.cents - total), nextTier.label);
        } else if (this.tiers.length > 0) {
          this.dataset.state = 'success';
          if (this.msgProgress) this.msgProgress.hidden = true;
          if (this.msgSuccess) this.msgSuccess.hidden = false;
        }

        let anyUnlocked = false;
        this.tiers.forEach(tier => {
          const added = tier.reached && tier.giftLines.length > 0;
          const state = !tier.reached ? 'locked' : (added ? 'added' : 'unlocked');
          tier.el.dataset.state = state;
          tier.el.hidden = state === 'locked' && tier.hideLocked;
          const show = (sel, on) => { const el = tier.el.querySelector(sel); if (el) el.hidden = !on; };
          show('[data-status-locked]', state === 'locked');
          show('[data-status-choose]', state === 'unlocked');
          show('[data-status-added]', state === 'added');
          if (tier.addBtn) {
            tier.addBtn.hidden = state !== 'unlocked';
            tier.addBtn.disabled = !this.getActiveSelection(tier);
          }
          tier.cards.forEach(c => c.setAttribute('tabindex', tier.reached ? '0' : '-1'));
          if (added && !tier.userTouched) this.syncSelectionFromCart(tier, tier.giftLines[0]);
          if (tier.reached) anyUnlocked = true;
        });
        if (this.hintEl) this.hintEl.hidden = !this.autoAdd || !anyUnlocked;
      }

      // Calcule et applique les écarts entre le panier et les règles des paliers
      async reconcile(cart, opts = {}) {
        if (this.designMode) return;
        if (this.busy) {
          // Choix client pendant une opération : rejoué à la fin sur un panier frais
          this.pendingRefresh = true;
          if (opts.swapTier || opts.manualTier) this.pendingOpts = opts;
          return;
        }
        if (!cart) return;
        const { total, orphans } = this.readCart(cart);
        const updates = {};
        const adds = [];

        this.tiers.forEach(tier => {
          const lines = tier.giftLines;
          if (!tier.reached) {
            // Panier retombé sous le seuil : retrait du cadeau de ce palier uniquement
            lines.forEach(l => { updates[l.key] = 0; });
            return;
          }
          // 1 cadeau max par palier (1 ligne, quantité 1)
          lines.slice(1).forEach(l => { updates[l.key] = 0; });
          if (lines[0] && (lines[0].quantity || 1) > 1) updates[lines[0].key] = 1;

          const sel = this.getActiveSelection(tier);
          if (!sel || this.failedVariants.has(String(sel.variantId))) return;
          const wantsAdd = this.autoAdd || opts.manualTier === tier;
          if (!lines[0]) {
            if (wantsAdd) adds.push({ id: parseInt(sel.variantId, 10), quantity: 1, properties: { _gift: 'true', _gift_tier: String(tier.cents) } });
          } else if ((opts.swapTier === tier || opts.manualTier === tier) && String(lines[0].variant_id) !== String(sel.variantId)) {
            updates[lines[0].key] = 0;
            adds.push({ id: parseInt(sel.variantId, 10), quantity: 1, properties: { _gift: 'true', _gift_tier: String(tier.cents) } });
          }
        });

        // Cadeaux hors config (palier supprimé ou épuisé) : retirés si leur seuil n'est plus atteint
        orphans.forEach(({ line, cents }) => { if (total < cents) updates[line.key] = 0; });

        if (Object.keys(updates).length === 0 && adds.length === 0) return;

        this.busy = true;
        let changed = false;
        try {
          if (Object.keys(updates).length > 0) {
            const res = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates })
            });
            if (res.ok) changed = true;
            else console.warn('[AndartaFreeGift] update HTTP', res.status);
          }
          for (const item of adds) {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] })
            });
            if (res.ok) {
              changed = true;
            } else {
              // Variante non ajoutable (brouillon, non publiée, rupture) : on n'insiste pas pendant cette visite
              this.failedVariants.add(String(item.id));
              console.warn('[AndartaFreeGift] addGift HTTP', res.status, 'variant', item.id);
            }
          }
          const fresh = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
          this.lastCart = fresh;
          const { total: freshTotal } = this.readCart(fresh);
          this.render(freshTotal);
          if (changed) await this.dispatchCartEvents(fresh);
        } catch (e) {
          console.warn('[AndartaFreeGift] reconcile failed', e);
        } finally {
          this.busy = false;
          if (this.pendingRefresh || this.pendingOpts) {
            const nextOpts = this.pendingOpts || {};
            this.pendingRefresh = false;
            this.pendingOpts = null;
            this.fetchCart(nextOpts);
          }
        }
      }

      async dispatchCartEvents(cart) {
        const detail = { source: 'andarta-free-gift' };
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
        // Section Rendering API : recharge HTML rendered SERVER (trusted Shopify) des sections cart
        try {
          const sectionIds = this.cartSectionsToRender();
          if (sectionIds.length > 0) {
            const url = '/cart?sections=' + sectionIds.join(',');
            const html = await fetch(url, { headers: { Accept: 'application/json' } }).then(r => r.json());
            for (const id of sectionIds) {
              const section = document.getElementById('shopify-section-' + id);
              if (!section || !html[id]) continue;
              // Parse HTML server-trusted (pattern Dawn natif cart.js renderContents)
              const doc = new DOMParser().parseFromString(html[id], 'text/html');
              const newInner = doc.getElementById('shopify-section-' + id);
              const fresh = newInner ? newInner.children : doc.body.children;
              section.replaceChildren(...Array.from(fresh).map(n => n.cloneNode(true)));
            }
          }
        } catch (e) { console.warn('[AndartaFreeGift] sections rerender failed', e); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'andarta-free-gift', cartData: cart }); } catch {}
        }
      }

      cartSectionsToRender() {
        // Détecte les sections cart présentes dans le DOM (rendues par cart.json)
        const candidates = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble', 'cart-live-region-text'];
        return candidates.filter(id => document.getElementById('shopify-section-' + id));
      }

      // "Plus que {remaining} pour recevoir {gift}" → montant en gras, libellé du prochain palier
      renderProgress(remaining, gift) {
        if (!this.msgProgress) return;
        this.msgProgress.replaceChildren();
        this.progressTemplate.split(/(\{remaining\}|\{gift\})/).forEach(part => {
          if (part === '{remaining}') {
            const strong = document.createElement('strong');
            strong.textContent = remaining;
            this.msgProgress.appendChild(strong);
          } else if (part === '{gift}') {
            this.msgProgress.appendChild(document.createTextNode(gift));
          } else if (part) {
            this.msgProgress.appendChild(document.createTextNode(part));
          }
        });
      }

      formatPrice(cents) {
        const amount = (cents / 100).toFixed(2).replace('.', ',');
        const sym = { EUR: '€', USD: '$', GBP: '£' };
        return `${amount} ${sym[this.currency] || this.currency}`;
      }
    }
    customElements.define('andarta-free-gift', AndartaFreeGift);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
